export default {
  DO_LOGIN: 'doLogin',
  DO_LOGOUT: 'doLogout',
  RENEW_TOKEN: 'renewToken',
  CHECK_TOKEN: 'checkToken',
  SYNC_STORED_TOKEN: 'syncStoredToken',
  SAVE_LOGIN_DATA: 'saveLoginData',
  RESET_LOGIN_DATA: 'resetLoginData',
  RESET_PASSWORD: 'resetPasswd',
}
